import React, { useEffect, useState } from 'react';
import { Alert, Button, Modal, Spinner } from 'react-bootstrap';
import { consumeAllFragments } from '../../apis/atlantis.api';

const ConsumeFragmentsModal = ({ show, onHide, request, token }) => {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  useEffect(() => {
    if (!show) {
      return;
    }

    setLoading(false);
    setResult(null);
  }, [show, request]);

  const handleClose = () => {
    if (loading) {
      return;
    }

    onHide();
  };

  const handleConfirm = async () => {
    if (!request?.walletId || loading) {
      return;
    }

    setLoading(true);
    setResult(null);

    try {
      const body = {};

      if (request.reason) {
        body.reason = request.reason;
      }

      const response = await consumeAllFragments(request.walletId, body, token);

      if (response?.changed) {
        setResult({
          variant: 'success',
          message: 'Points consumed successfully.',
          response,
        });
      } else {
        setResult({
          variant: 'info',
          message: 'No points to consume for this wallet.',
        });
      }
    } catch (error) {
      setResult({
        variant: 'danger',
        message: 'Something went wrong.',
      });
    } finally {
      setLoading(false);
    }
  };

  const hasResult = Boolean(result);

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      backdrop={loading ? 'static' : true}
      keyboard={!loading}
    >
      <Modal.Header closeButton={!loading}>
        <Modal.Title>Consume Points</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-3">Confirm that you want to consume all points for this wallet.</p>

        <dl className="row mb-0">
          <dt className="col-sm-4">Wallet ID</dt>
          <dd className="col-sm-8 text-break">{request?.walletId}</dd>

          <dt className="col-sm-4">Reason</dt>
          <dd className="col-sm-8 text-break">{request?.reason || 'Not provided'}</dd>
        </dl>

        {result && (
          <Alert variant={result.variant} className="mt-4 mb-0">
            <div>{result.message}</div>
            {result.variant === 'success' && (
              <div className="mt-2">
                <div>
                  <strong>Consumed:</strong> {result.response?.consumedFragments ?? 0}
                </div>
                <div>
                  <strong>Audit ID:</strong> {result.response?.auditId || 'N/A'}
                </div>
              </div>
            )}
          </Alert>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose} disabled={loading}>
          {hasResult ? 'Close' : 'Cancel'}
        </Button>
        {!hasResult && (
          <Button variant="danger" onClick={handleConfirm} disabled={loading}>
            {loading ? (
              <>
                <Spinner as="span" animation="border" size="sm" className="me-2" />
                Consuming...
              </>
            ) : (
              'Confirm'
            )}
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default ConsumeFragmentsModal;
